console.log("style-guide.js is loaded");

// select all buttons with class "testButton"
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".testButton").forEach(button => {
    button.addEventListener("click", () => {
      console.log(" THE TEST BUTTON WAS CLICKED!");
    });
  });
});

document.addEventListener("DOMContentLoaded", () => {
  // Parse JSON from hidden div
  const dataDiv = document.getElementById("size-guide-data");
  if (!dataDiv) return; // No size data on this page
  let sizeData = [];
  try {
    sizeData = JSON.parse(dataDiv.textContent);
  } catch(e) {
    console.error("Invalid size guide JSON:", e);
    return;
  }

  // Get modal elements
  const modal = document.getElementById("size-guide-modal");
  const tableContainer = document.getElementById("size-guide-table-container");
  const closeButton = document.getElementById("close-size-guide");

  // Build table
  const table = document.createElement("table");
  table.style.width = "100%";
  table.style.borderCollapse = "collapse";
  table.style.marginTop = "1rem";

  // Header row
  const header = document.createElement("tr");
  ["Size", "Bust", "Waist", "Hip"].forEach(text => {
    const th = document.createElement("th");
    th.textContent = text;
    th.style.border = "1px solid #ccc";
    th.style.padding = "0.5rem";
    th.style.textAlign = "center";
    table.appendChild(th.parentElement ? th.parentElement : header);
  });
  table.appendChild(header);

  // Data rows
  sizeData.forEach(row => {
    const tr = document.createElement("tr");
    ["size","bust","waist","hip"].forEach(key => {
      const td = document.createElement("td");
      td.textContent = row[key];
      td.style.border = "1px solid #ccc";
      td.style.padding = "0.5rem";
      td.style.textAlign = "center";
      tr.appendChild(td);
    });
    table.appendChild(tr);
  });

  tableContainer.appendChild(table);

  // Open modal
  document.querySelectorAll(".open-size-guide").forEach(button => {
    button.addEventListener("click", () => {
      modal.style.display = "flex";
    });
  });

  // Close modal
  closeButton.addEventListener("click", () => {
    modal.style.display = "none";
  });

  // Close modal if clicking outside content
  modal.addEventListener("click", (e) => {
    if (e.target === modal) modal.style.display = "none";
  });
});


